export default "__VITE_ASSET__kB9n1l_$__"